import React from 'react';
import Button from 'ui/Button';
import Spinner from '../../../ecoui/UISpinner';
import { countDeadlineTime, hasAvailableShares } from '../state/helpers';
import useCountdown from 'features/SpilKlub/state/useCountdown';
import AddSharesButton from 'features/SpilKlub/components/AddSharesButton';
import useAuth from '../state/useAuth';
import { connect } from 'react-redux';
import { authHandler } from '../index';
import { bindActionCreators } from 'redux';
import * as UiActions from 'actions/UiActions';
import { POOL_DETAILS_SLUG } from '../screens/useScreens';
import { detectMobile } from '../../../utils/UiHelper';

const BuyShares = ({
    pool,
    status,
    setSelectShares,
    uiActions,
    onClick = () => {},
}) => {
    const availableShares = hasAvailableShares(pool);
    const pending = status === 'loading';

    const deadlineTime = countDeadlineTime(
        pool?.poolSettings?.deadlineTime,
        pool?.startTime
    );
    const { timeIsOver } = useCountdown({
        deadlineTime,
    });

    const { loggedIn } = useAuth();

    const onBuySharesClick = () => {
        if (!loggedIn) {
            authHandler(uiActions, POOL_DETAILS_SLUG);
        }

        if (!hasPlacedBets && availableShares && loggedIn) {
            setSelectShares(1);
            onClick();
        }
    };

    const hasPlacedBets = pool?.placedCouponsAmount > 0 || timeIsOver;

    return (
        <div className="align-self-center sk-shares-button-wrapper flex-grow flex justify-end">
            {pending ? (
                <Spinner plain size="fa-05x" className="no-padding" />
            ) : (
                <Button
                    width={detectMobile() ? '160px' : '180px'}
                    padding={detectMobile() ? '15px 30px' : '13px 30px 12px'}
                    fontSize="16px"
                    /*height={detectMobile() ? '49px' : '44px'}*/
                    margin="0"
                    neutral={hasPlacedBets}
                    active={availableShares && !hasPlacedBets}
                    red={!availableShares && !hasPlacedBets}
                    onClick={onBuySharesClick}
                >
                    {hasPlacedBets
                        ? 'Lukket for køb'
                        : availableShares
                            ? 'Køb andel'
                            : 'Udsolgt'}
                </Button>
            )}
        </div>
    );
};

function mapDispatchToProps(dispatch) {
    return {
        uiActions: bindActionCreators(UiActions, dispatch),
    };
}

export default connect(
    null,
    mapDispatchToProps
)(BuyShares);
